export default function Marquee({ items, className = "", testId = "marquee" }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden border-y border-white/10 ${className}`} data-testid={testId}>
      <div className="animate-marquee flex w-max py-6">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-10 whitespace-nowrap px-10 font-display text-2xl font-semibold uppercase tracking-tight text-white/70 md:text-4xl"
          >
            {item}
            <span className="inline-block h-2 w-2 rotate-45 bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
}
